var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCompartir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1423",
    "data-name": "Grupo 1423",
    transform: "translate(-1054 -2654)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_112",
    "data-name": "Elipse 112",
    cx: 44.5,
    cy: 44,
    rx: 44.5,
    ry: 44,
    transform: "translate(1054 2654)",
    fill: "rgba(0,170,255,0.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(1062 2661)",
    fill: "#1de9b6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_943",
    "data-name": "Grupo 943",
    transform: "translate(1079.535 2677.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_917",
    "data-name": "Grupo 917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_686",
    "data-name": "Trazado 686",
    d: "M212.215,380.747a3.948,3.948,0,0,1-3.227-4.545,1.033,1.033,0,0,0-.524-1.094c-2.306-1.711-4.611-3.423-6.9-5.163a1.04,1.04,0,0,0-1.185-.1,4.02,4.02,0,0,1-5.5-3.36,4.179,4.179,0,0,1,2.088-4.107,3.925,3.925,0,0,1,4.56.525,1.214,1.214,0,0,0,1.372.31q3.981-1.208,7.986-2.333a1.169,1.169,0,0,0,.954-1.047,3.854,3.854,0,0,1,4.78-2.857,3.991,3.991,0,0,1,3.065,4.356,3.909,3.909,0,0,1-2.7,3.514,3.993,3.993,0,0,1-4.218-1,1.121,1.121,0,0,0-.922-.2q-4.194,1.218-8.362,2.525c-.245.076-.59.337-.606.535a1.089,1.089,0,0,0,.393.8c2.314,1.8,4.659,3.55,6.972,5.349.443.345.773.171,1.191.018a3.886,3.886,0,0,1,4.3.86,3.969,3.969,0,0,1,.938,4.512,3.78,3.78,0,0,1-3.333,2.557,6.84,6.84,0,0,1-1.131-.052",
    transform: "translate(-184.792 -338.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_687",
    "data-name": "Trazado 687",
    d: "M192.778,335.541a18.3,18.3,0,0,1,13.273-.16c.1.037.2.074.3.118a1.26,1.26,0,0,1,.754,1.611,1.237,1.237,0,0,1-1.6.712,28.48,28.48,0,0,0-3.9-.963,16.367,16.367,0,0,0-16.946,9.564,2.093,2.093,0,0,1-.558.785,1.069,1.069,0,0,1-1.437-.068,1.16,1.16,0,0,1-.3-1.5A36.762,36.762,0,0,1,184.4,342.1a19.019,19.019,0,0,1,8.38-6.561",
    transform: "translate(-182.208 -334.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_688",
    "data-name": "Trazado 688",
    d: "M195.725,342.367a12.944,12.944,0,0,1,10.02-.1,1.282,1.282,0,0,1,.925,1.351,1.1,1.1,0,0,1-.926,1.054,1.744,1.744,0,0,1-.877-.105c-5.776-2.106-11.352.248-13.983,5.913a1.247,1.247,0,0,1-1.67.8,1.318,1.318,0,0,1-.525-1.862,13.243,13.243,0,0,1,7.036-7.053",
    transform: "translate(-183.497 -335.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_689",
    "data-name": "Trazado 689",
    d: "M206.178,349.668a5.191,5.191,0,0,1-.45,1.261,1.055,1.055,0,0,1-1.354.294,5.488,5.488,0,0,0-3.309-.3,5.6,5.6,0,0,0-4.056,3.382,1.2,1.2,0,0,1-1.274.821,1.1,1.1,0,0,1-1.032-.945,1.629,1.629,0,0,1,.081-.831c1.478-4.02,6.695-6.216,10.487-4.411a5.652,5.652,0,0,1,.907.73",
    transform: "translate(-184.755 -337.091)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_690",
    "data-name": "Trazado 690",
    d: "M204.355,355.731a1.524,1.524,0,0,1-.865,2,1.475,1.475,0,0,1-1.952-.9,1.582,1.582,0,0,1,.839-1.977,1.522,1.522,0,0,1,1.978.874",
    transform: "translate(-186.136 -338.407)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompartir);
export default __webpack_public_path__ + "static/media/ic_compartir.02dd16e059dd3d4dfd8b839a67333302.svg";
export { ForwardRef as ReactComponent };